const colors = {
  Orange: '#FF8A2D',
  Red: '#E7314C',
  Green: '#27D182',
  Blue: '#002665'
}

export default colors



// WEBPACK FOOTER //
// ./src/colors.js